import {EZPRTheme} from '../../_theme';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, ThemeProvider, Button, IconButton} from '@mui/material';
import {CandexMarketsDropdown} from './CandexMarketsDropdown.jsx';
import {ezprOrange} from '../../_helpers';
import CloseIcon from '@mui/icons-material/Close';
import {BrickContext} from 'olympe';

/**
 * This is the content of the Candex popup
 * @param {CandexContent.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function CandexContent(props) {
    const [open, setOpen] = useState(true);
    const [selectedMarket, setSelectedMarket] = useState(null);

    const handleClose = () => {
        if (selectedMarket) {
            const newUrl = `${selectedMarket.url}?UserName=${selectedMarket.username}&Password=${selectedMarket.decryptedPassword}&UserEmail=`;
            props.setURL(newUrl);
            props.setCompanyCode(selectedMarket.company_code);
        } else {
            props.setURL(null);
            props.setCompanyCode(null);
        }
        setOpen(false);
        document.getElementById('popup019538b4996a84cb5ab2').remove();
        if (selectedMarket) {
            props.forwardEvent();
        }
    };

    const handleDropdownChange = (market) => {
        setSelectedMarket(market);
    };

    return (
        <ThemeProvider theme={EZPRTheme}>
            <Dialog open={open} onClose={handleClose} maxWidth="lg">
                <div className={'popup-candex-header'}>
                    <DialogTitle>Which Candex catalog would you like to use?</DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            color: ezprOrange,
                        }}>
                        <CloseIcon
                            sx={{
                                width: '50px',
                                height: '50px',
                            }}
                        />
                    </IconButton>
                </div>
                <DialogContent className="popup-candex-container">
                    <div className="popup-candex-content">
                        <CandexMarketsDropdown
                            context={props.context}
                            candexTableData={props.candexTableData}
                            decryptPassword={props.decryptPassword}
                            companyCodesAuthorized={props.companyCodesAuthorized}
                            selectedValue={selectedMarket}
                            onChange={handleDropdownChange}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            'color': '#fff',
                            'backgroundColor': ezprOrange,
                            '&:hover': {backgroundColor: '#F2ae49'},
                            ':disabled': {backgroundColor: 'rgba(0,0,0,0.26)'},
                        }}
                        variant="outlined"
                        onClick={handleClose}
                        disabled={!selectedMarket}
                    >
                        <span>Open</span>
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

CandexContent.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    forwardEvent: PropTypes.func,
    setURL: PropTypes.func,
    setCompanyCode: PropTypes.func,
    candexTableData: PropTypes.string,
    decryptPassword: PropTypes.object,
    companyCodesAuthorized: PropTypes.array,
};
